module.exports = __webpack_public_path__ + "img/cbiz.b32a16ba.svg";